import { AnimationStates } from 'core/constants/animation-states';
import { createContext, ReactElement, useContext, useState } from 'react';
import FadeWrapper from 'shared/components/animation/fade-wrapper';
import { motion } from 'framer-motion';

interface IDialogContext {
  showDialog: boolean;
  openDialog: (dialogTemplate: ReactElement) => void;
  closeDialog: () => void;
  replaceDialog: (dialogTemplate: ReactElement) => void;
  setDialogTemplate: (dialogTemplate: ReactElement) => void;
}

export const DialogContext = createContext<IDialogContext | null>(null);

export const useDialog = () => useContext(DialogContext);

export const DialogProvider = ({ children }: any) => {
  const [showDialog, setShowDialog] = useState(false);
  const [dialogTemplate, setDialogTemplate] = useState<ReactElement | null>(null);
  const [animationState, setAnimationState] = useState(AnimationStates.ENTERING);

  const openDialog = (dialogTemplate: ReactElement) => {
    setShowDialog(true);
    setDialogTemplate(dialogTemplate);
  };

  const replaceDialog = (dialogTemplate: ReactElement) => {
    setAnimationState(AnimationStates.EXITING);
    setTimeout(() => {
      setShowDialog(false);
      setDialogTemplate(null);
      setAnimationState(AnimationStates.ENTERING);
      openDialog(dialogTemplate);
    }, 200);
  };

  const closeDialog = () => {
    setAnimationState(AnimationStates.EXITING);
    setTimeout(() => {
      setShowDialog(false);
      setDialogTemplate(null);
      setAnimationState(AnimationStates.ENTERING);
    }, 200);
  };

  return (
    <DialogContext.Provider value={{ showDialog, openDialog, closeDialog, replaceDialog, setDialogTemplate }}>
      <div className='z-50'>
        {showDialog && (
          <FadeWrapper
            animationState={animationState}
            className='w-full h-full fixed top-0 left-0 bg-black bg-opacity-25 z-50 flex justify-center items-center p-4'
          >
            <motion.div
              className='w-full max-h-full flex justify-center'
              initial={{ translateY: 20 }}
              animate={{ translateY: animationState === AnimationStates.EXITING ? 20 : 0 }}
              transition={{ duration: 0.2 }}
            >
              {dialogTemplate}
            </motion.div>
          </FadeWrapper>
        )}
      </div>
      {children}
    </DialogContext.Provider>
  );
};
